module.exports = __webpack_public_path__ + "img/honor_3.c9252ffa.png";